import React, { useRef, useState } from "react";
import { Tooltip, Popover } from "@mui/material";
import { IconButton } from "@mui/material";
// import AsiaCup2025 from '../../../images/AsiaCup2025.png'

const A1Event = (props) => {
  const [clicked, setClicked] = useState(false);

  let parsedData = null;
  try {
    parsedData = props?.item?.data ? JSON.parse(props.item.data) : null;
  } catch {
    // ignore
  }
  const isLive = parsedData?.show === "live";

  const getButtonContent = () => (
    <>
      {parsedData?.img && (
        <img src={parsedData.img} alt={props?.item?.text} style={{  width:isLive ? "38px" : "24px", height: "24px", opacity: 0.9, mixBlendMode: "darken" }} />
      )}
      {props?.item?.text}
      <span className={`a1-live-indicator ${clicked ? "a1-live-paused" : ""}`}>LIVE</span>
    </>
  );

  // const checkButton = () => {
  //   let userText = props?.item?.text;
  //   const buttonTextOptions = ["Yes", "No", "Submit", "Confirm" ,"Send OTP"];

  //   // Check if any of the options are included in userText
  //   if (buttonTextOptions.some(option => userText.includes(option))) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  const checkButton = () => {
    let userText = props?.item?.text;
    const buttonTextOptions = ["Yes", "No", "Submit", "Confirm", "Send OTP", "Got it"];

    return buttonTextOptions.includes(userText);
  };

  const onClickHandler = (e) => {
    if (!props.disable) {
      const parsed = JSON.parse(props?.item?.data || "{}");
      props.closeNudges?.();
      props.handleClick(props.item.code,parsed?.value );
      props.setTextOnClick(props.item.text);
      props.setSubTextOnClick(props?.item?.infoText || '')
      setClicked(true);
    }
  };

  return (
    <>
 
        <button
          className={
            props.isFallback
              ? "chat-label action-tab"
              : `${props?.item?.text === "Upload Image" ? "chat-label-fallback" : "chat-label action-tab"} `
          }
          id="main-tab1"
          style={{
            color: clicked && "grey",
            pointerEvents: clicked && "none",
            borderRadius: checkButton() ? "4px" : "44px",
            position: "relative",
            overflow: "visible", // allow badge outside
            paddingRight: "16px", // some breathing room
            
          }}
          onClick={onClickHandler}
          ref={(el) => {
            if (el) {
              try {
                const { color } = JSON.parse(props?.item?.data || "{}");
                if (color) {
                  el.style.setProperty("background-color", color, "important");
                  el.style.setProperty("color", "white", "important");
                }
              } catch {
                // ignore parsing errors
              }
            }
          }}
        >
          {isLive ? getButtonContent() : (
            <>
              {(() => {
                try {
                  const parsed = JSON.parse(props?.item?.data || "{}");
                  if (parsed?.img) {
                    return (
                      <img
                        src={parsed?.img}
                        alt={props?.item?.text}
                        style={{
                          width:isLive ? "38px" : "24px",
                          height: "24px",
                          opacity: 0.9,
                          mixBlendMode: "darken",
                        }}
                      />
                    );
                  }
                } catch {
                  return null;
                }
                return null;
              })()}
              {props?.item?.text}
            </>
          )}

          {/* NEW Tag */}
          {(() => {
            try {
              const parsed = JSON.parse(props?.item?.data || "{}");
              return parsed?.button === "new" ? (
                <span
                  style={{
                    position: "absolute",
                    top: "-12px",    // move above button
                    right: "4px",    // align with right corner
                    background: "red",
                    color: "white",
                    fontSize: "10px",
                    fontWeight: "bold",
                    padding: "2px 6px",
                    borderRadius: "10px",
                    whiteSpace: "nowrap",
                    marginLeft: '6px'
                  }}
                >
                  NEW
                </span>
              ) : null;
            } catch {
              return null;
            }
          })()}
        </button>
    </>
  );
};

export default A1Event;
